export enum AlertType {
  Banner,
  Success,
  Error,
  Info,
  Warning,
}

export enum AlertTitle {
  Banner = 'Nice Work!',
  Success = 'Success!',
  Error = 'Error!',
  Info = 'Information',
  Warning = 'Warning!',
  EditProfile = 'Editing disabled',
}

export enum AlertIcon {
  Banner = 'fa-party-horn',
  Success = 'fa-circle-check',
  Error = 'fa-circle-exclamation',
  Info = 'fa-circle-info',
  Warning = 'fa-exclamation-triangle',
}

export class Alert {
  icon: string;
  id: string;
  fade: boolean;
  message: string;
  title: AlertTitle;
  type: AlertType;
  autoDisappear = true;
  uniqueId: number;

  constructor(init?: Partial<Alert>) {
    Object.assign(this, init);
  }
}
